import { render } from "./TrainingRequestFormView.vue?vue&type=template&id=08acc71a"
import script from "./TrainingRequestFormView.vue?vue&type=script&lang=js"
export * from "./TrainingRequestFormView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__